export const ADD_MAIN_CATEGORY = "ADD_MAIN_CATEGORY";
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";

export const REMOVE_MAIN_CATEGORY = "REMOVE_MAIN_CATEGORY";
export const REMOVE_SUB_CATEGORY = "REMOVE_SUB_CATEGORY";

export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_CATEGORY_TITLE = "UPDATE_CATEGORY_TITLE";
export const UPDATE_GOOGLE_TAXONOMY = "UPDATE_GOOGLE_TAXONOMY";
export const UPDATE_SUB_CATEGORY_IMAGE = "UPDATE_SUB_CATEGORY_IMAGE";
export const UPDATE_SUB_CATEGORY_TITLE = "UPDATE_SUB_CATEGORY_TITLE";


// WEBPACK FOOTER //
// ./src/components/category/actions/types.js